var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToalett(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.998,
    cy: 2.75,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.078,7 L0.002,19.917 L1.995,20.083 L2,20.021 L2,32 L4,32 L4,19 L6,19 L6,32 L8,32 L8,20.062 L8.002,20.083 L9.995,19.917 L8.918,7 L1.078,7 Z M2.252,17 L2.919,9 L7.079,9 L7.746,17 L2.252,17 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.997,
    cy: 3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.98 18.821L26.832 7 19.162 7 17.014 18.821 18.981 19.178 19.001 19.068 19.001 23 20.001 23 20.001 32 22.001 32 22.001 23 24.001 23 24.001 32 26.001 32 26.001 23 27.001 23 27.001 19.106 27.014 19.178 28.98 18.821zM21 9L25 9 25 21 21 21 21 9zM27.43 6.306L27.996 6.306 27.996 5.74C27.996 4.779 27.217 4 26.256 4L25.69 4 25.69 4.566C25.691 5.527 26.47 6.306 27.43 6.306z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 32,
    x: 13
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToalett);
export default __webpack_public_path__ + "static/media/Toalett.673b2c9ff168b06f5cb30478ba9bf0c0.svg";
export { ForwardRef as ReactComponent };